var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-list" },
    [
      _c("input", {
        ref: "refImportBase",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".xlsx, .xls" },
        on: { change: _vm.uploadBase },
      }),
      _vm._v(" "),
      _c("input", {
        ref: "refImportSummary",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".xlsx, .xls" },
        on: { change: _vm.uploadSummary },
      }),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "statistics-area" }, [
            _c("div", { staticClass: "stat-item" }, [
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("金额（不含税）"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-value green" }, [
                _vm._v("¥" + _vm._s("4928438.52")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-item" }, [
              _c("div", { staticClass: "stat-label" }, [_vm._v("税额")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-value blue" }, [
                _vm._v("¥" + _vm._s("49284.48")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-item" }, [
              _c("div", { staticClass: "stat-label" }, [_vm._v("价税合计")]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-value orange" }, [
                _vm._v("¥" + _vm._s("4977723.00")),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "search-area" }, [
            _c(
              "div",
              { staticClass: "search-row" },
              [
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("数电发票号码:"),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "240px" },
                      attrs: { placeholder: "请输入内容", size: "small" },
                      model: {
                        value: _vm.searchForm.invoiceNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "invoiceNo", $$v)
                        },
                        expression: "searchForm.invoiceNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.handleReset } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "quick-filters" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAction("importBase")
                      },
                    },
                  },
                  [_vm._v("导入发票基础信息")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAction("exportBase")
                      },
                    },
                  },
                  [_vm._v("导出发票基础信息")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAction("importSummary")
                      },
                    },
                  },
                  [_vm._v("导入汇总工表单")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAction("exportSummary")
                      },
                    },
                  },
                  [_vm._v("导出汇总工表单")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                border: "",
                "expand-row-keys": _vm.expandedRows,
                "row-key": "invoiceNo",
              },
              on: { "expand-change": _vm.handleExpandChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.expandLoading[props.row.invoiceNo],
                                expression:
                                  "expandLoading[props.row.invoiceNo]",
                              },
                            ],
                            staticClass: "expand-container",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "expand-section" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v("基础信息"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "expand-form",
                                    attrs: {
                                      "label-width": "120px",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      { attrs: { gutter: 20 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "数电发票号码：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].invoiceNo) ||
                                                      props.row.invoiceNo
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "开票日期：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].invoiceDate) ||
                                                      props.row.invoiceDate
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "销方识别号：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].sellerTaxId) ||
                                                      props.row.sellerTaxId
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "销方名称：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].sellerName) ||
                                                      props.row.sellerName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "购方识别号：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].buyerTaxId) ||
                                                      props.row.buyerTaxId
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "购买方名称：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].buyerName) ||
                                                      props.row.buyerName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "金额：" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].amount) ||
                                                      props.row.amount
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "税额：" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].taxAmount) ||
                                                      props.row.taxAmount
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "价税合计：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].totalAmount) ||
                                                      props.row.totalAmount
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "发票来源：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].invoiceSource) ||
                                                      props.row.invoiceSource
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "发票票种：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].invoiceType) ||
                                                      props.row.invoiceType
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "发票状态：" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].invoiceStatus) ||
                                                      props.row.invoiceStatus
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "是否正数发票：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].isPositive) ||
                                                      props.row.isPositive
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "发票风险等级：",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].riskLevel) ||
                                                      props.row.riskLevel
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "开票人：" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].issuer) ||
                                                      props.row.issuer
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "备注：" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.expandData[
                                                      props.row.invoiceNo
                                                    ] &&
                                                      _vm.expandData[
                                                        props.row.invoiceNo
                                                      ].remark) ||
                                                      props.row.remark
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "expand-section" },
                              [
                                _c("div", { staticClass: "section-title" }, [
                                  _vm._v("发票明细"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-table",
                                  {
                                    staticClass: "detail-table",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data:
                                        (_vm.expandData[props.row.invoiceNo] &&
                                          _vm.expandData[props.row.invoiceNo]
                                            .detailList) ||
                                        [],
                                      size: "mini",
                                      border: "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "index",
                                        label: "序号",
                                        width: "60",
                                        align: "center",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "taxCategoryCode",
                                        label: "税收分类编码",
                                        "min-width": "150",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goodsName",
                                        label: "货物或应税劳务名称",
                                        "min-width": "180",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "specification",
                                        label: "规格型号",
                                        "min-width": "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "unit",
                                        label: "单位",
                                        width: "80",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "quantity",
                                        label: "数量",
                                        width: "100",
                                        align: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      scope.row.quantity || "-"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "unitPrice",
                                        label: "单价",
                                        width: "120",
                                        align: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      scope.row.unitPrice || "-"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "amount",
                                        label: "金额",
                                        width: "120",
                                        align: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      scope.row.amount || "0.00"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "taxRate",
                                        label: "税率",
                                        width: "80",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "taxAmount",
                                        label: "税额",
                                        width: "120",
                                        align: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      scope.row.taxAmount ||
                                                        "0.00"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "totalAmount",
                                        label: "价税合计",
                                        width: "120",
                                        align: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      scope.row.totalAmount ||
                                                        "0.00"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "remark",
                                        label: "备注",
                                        "min-width": "120",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.expandData[props.row.invoiceNo] &&
                                _vm.expandData[props.row.invoiceNo]
                                  .detailTotal > 0
                                  ? _c("el-pagination", {
                                      staticClass: "detail-pagination",
                                      attrs: {
                                        "page-sizes": [10, 20, 30, 50],
                                        "page-size":
                                          (_vm.expandPagination[
                                            props.row.invoiceNo
                                          ] &&
                                            _vm.expandPagination[
                                              props.row.invoiceNo
                                            ].limit) ||
                                          10,
                                        "current-page":
                                          (_vm.expandPagination[
                                            props.row.invoiceNo
                                          ] &&
                                            _vm.expandPagination[
                                              props.row.invoiceNo
                                            ].page) ||
                                          1,
                                        layout:
                                          "total, sizes, prev, pager, next, jumper",
                                        total:
                                          (_vm.expandData[
                                            props.row.invoiceNo
                                          ] &&
                                            _vm.expandData[props.row.invoiceNo]
                                              .detailTotal) ||
                                          0,
                                      },
                                      on: {
                                        "size-change": function (val) {
                                          return _vm.handleDetailSizeChange(
                                            val,
                                            props.row.invoiceNo
                                          )
                                        },
                                        "current-change": function (val) {
                                          return _vm.handleDetailPageChange(
                                            val,
                                            props.row.invoiceNo
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceNo",
                  label: "数电发票号码",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sellerTaxId",
                  label: "销方识别号",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sellerName",
                  label: "销方名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerTaxId",
                  label: "购方识别号",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerName",
                  label: "购买方名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceDate",
                  label: "开票日期",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "金额",
                  "min-width": "120",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.amount || "0.00") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taxAmount",
                  label: "税额",
                  "min-width": "120",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.taxAmount || "0.00") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalAmount",
                  label: "价税合计",
                  "min-width": "120",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.totalAmount || "0.00") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceSource",
                  label: "发票来源",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceType",
                  label: "发票票种",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceStatus",
                  label: "发票状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isPositive",
                  label: "是否正数发票",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "riskLevel",
                  label: "发票风险等级",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "issuer", label: "开票人", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "150" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [15, 30, 45, 60],
              "page-size": _vm.searchForm.limit,
              "current-page": _vm.searchForm.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }